module.exports = __webpack_public_path__ + "static/media/icon_navigation_right.c42346f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/navigation/icon_navigation_right.svg
// module id = 463
// module chunks = 0